export function modelFromDto(roleDto, applicationGroupsDto) {
    return {
        id: roleDto.loginRole.id,
        roleName: roleDto.loginRole.roleName,
        roleValue: roleDto.loginRole.roleValue,
        groups: applicationGroupsDto.map((applicationGroup) => ({
            id: applicationGroup.group.id,
            type: applicationGroup.group.type,
            groupName: applicationGroup.group.groupName,
            applicationGroupId: applicationGroup.id,
            isSelected: roleDto.groupIds.includes(applicationGroup.id),
        })),
    };
}

export function modelToDto(model) {
    return {
        loginRole: {
            id: model.id,
            roleName: model.roleName,
            roleValue: model.roleValue,
        },
        groupIds: model.groups
            .filter((group) => group.isSelected)
            .map((group) => group.applicationGroupId)
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/roles.exports.js